<template>
    <form>
        <form-alert />

        <div class="form-group">
            <label for="title">
                Title
            </label>
            <form-input
                v-model="mutableData.title"
                name="title"
                data-vv-as="Title"
            />
        </div>

        <div class="form-group">
            <label for="title">
                Subtitle
            </label>
            <form-input
                v-model="mutableData.subtitle"
                name="subtitle"
                data-vv-as="Subtitle"
            />
        </div>

        <div class="form-group">
            <label for="slug">
                Slug
            </label>
            <form-input
                v-model="mutableData.slug"
                name="slug"
                data-vv-as="Slug"
            />
        </div>

        <div class="form-group">
            <label for="language_id">
                Language
            </label>
            <form-select
                v-model="mutableData.language_id"
                name="language_id"
                endpoint="/admin/api/languages-options"
                data-vv-as="Language"
            >
            </form-select>
        </div>

        <div class="form-group">
            <label for="content">
                Content
            </label>
            <trumbowyg
                v-model="mutableData.content"
                :config="config"
                class="form-control"
                name="content"
                data-vv-as="Content"
            >
            </trumbowyg>
        </div>

        <form-alert />

        <button
            :disabled="isSending"
            class="btn btn-success btn-block"
            @click.prevent="submitForm()"
        >
            Save
        </button>
    </form>
</template>

<script>
import Form from "../mixins/Form.js";
import Trumbowyg from "../mixins/Trumbowyg.js";

export default {
  mixins: [
    Form,
    Trumbowyg,
  ],
};
</script>
